import { httpRequest } from "../http";

const BASE = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/admin/impersonate/`;

export interface StartImpersonationResponse {
    token: string;
    expires_at: string;
    impersonated_user: {
        id: number;
        email: string;
        first_name: string | null;
        last_name: string | null;
    };
}

export class ImpersonationService {
    /** Issued under the admin's token. Returns a fresh Knox token bound to
     * the target user (5 min TTL). The caller must swap it into appStore.
     * The proof is the admin's own password or a fresh Google id_token — the
     * server re-authenticates before minting anything, and rejects a Google token
     * older than five minutes. */
    async start(
        userId: number,
        reason: string,
        proof: { password?: string; googleIdToken?: string },
    ): Promise<StartImpersonationResponse> {
        return httpRequest<StartImpersonationResponse>(BASE, {
            method: "POST",
            body: {
                user_id: userId,
                reason,
                password: proof.password ?? null,
                google_id_token: proof.googleIdToken ?? null,
            },
        });
    }

    /** Called under the impersonation token — the request itself revokes
     * the token it's authenticated with. */
    async stop(): Promise<void> {
        await httpRequest<void>(`${BASE}stop/`, { method: "POST" });
    }

    /** Close a session whose token was never committed to the store, so the
     * ambient auth header would still be the admin's. */
    async stopWithToken(token: string): Promise<void> {
        await fetch(`${BASE}stop/`, {
            method: "POST",
            headers: { Authorization: `Token ${token}` },
        });
    }
}
